import {use} from 'react'
import {IconButton} from '@primer/react'
import {ThreeBarsIcon} from '@primer/octicons-react'
import {LayoutContext} from '@github-ui/pacer/Layout/layout-context'
import {SidebarPageLayout, useIsInsideSidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import styles from './TaskSidebarFallbackToggle.module.css'

// Sidebar toggle for task states (loading / error / empty) that render before
// the StickyTaskChatHeader mounts. It supports both the repo-less
// SidebarPageLayout and the legacy Pacer Layout, which is absent in side
// panels and Storybook.
export function TaskSidebarFallbackToggle() {
  const layoutContext = use(LayoutContext)
  const isInsideSidebarPageLayout = useIsInsideSidebarPageLayout()

  if (isInsideSidebarPageLayout) {
    return <SidebarPageLayout.SidebarTrigger className={styles.fallbackToggle} />
  }

  if (!layoutContext?.layoutBreakpoint) return null

  return (
    <div className={styles.fallbackToggle}>
      <IconButton
        icon={ThreeBarsIcon}
        aria-label="Toggle sidebar"
        variant="invisible"
        onClick={layoutContext.toggleSidebar}
        data-testid="task-fallback-sidebar-toggle"
      />
    </div>
  )
}
